/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RateItemVo
 */
export interface RateItemVo {
    /**
     * 附加服务id
     * @type {number}
     * @memberof RateItemVo
     */
    additionalServiceId: number;
    /**
     * 分成比例%（整数）
     * @type {number}
     * @memberof RateItemVo
     */
    rate: number;
}

/**
 * Check if a given object implements the RateItemVo interface.
 */
export function instanceOfRateItemVo(value: object): value is RateItemVo {
    if (!('additionalServiceId' in value) || value['additionalServiceId'] === undefined) return false;
    if (!('rate' in value) || value['rate'] === undefined) return false;
    return true;
}

export function RateItemVoFromJSON(json: any): RateItemVo {
    return RateItemVoFromJSONTyped(json, false);
}

export function RateItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RateItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'additionalServiceId': json['additionalServiceId'],
        'rate': json['rate'],
    };
}

export function RateItemVoToJSON(json: any): RateItemVo {
    return RateItemVoToJSONTyped(json, false);
}

export function RateItemVoToJSONTyped(value?: RateItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'additionalServiceId': value['additionalServiceId'],
        'rate': value['rate'],
    };
}

